import React, { useEffect, useState } from 'react';
import '../../scss/entity_tasks.scss';
import AddTask from '../popups/AddTask';
import AddTaskTemplate from '../popups/AddTaskTemplate';
import DeleteItem from '../popups/DeleteItem';
import Snackbars from '../Reusables/Snackbar';

import trash from '../../images/common/trash.png';
import trashDark from '../../images/common/trash-dark.png';
import upsort from '../../images/common/upsort.png';
import downsort from '../../images/common/downsort.png';

function EntityTasks(props) {
    const {handleTaskDetails, parseTaskDetails, addTaskShow, taskToggle} = props;
    const [show, setShow] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deletedTaskOrder, setDeletedTaskOrder] = useState(null);
    const [deletedTaskIndex, setDeletedTaskIndex] = useState(null);
    const [taskDetails, setTaskDetails] = useState(parseTaskDetails);
    const [sortingDetails, setSortingDetails] = useState(null);
    const [tableHeaders, setTableHeaders] = useState(null);
    const [taskerror, setTaskError] = useState('');
    const [sortValues, setSortValues] = useState({
        sortBy: null,
        sortType: null
    })
    const [taskDetailsshow, setTaskDetailsshow] = useState({projectTypeId: 0, idTaskTemplateTaskRelation: 0, taskName: null, order: null});
    const [taskTemplateDetails, setTaskTemplateDetails] = useState(
        {
            idTaskTemplateBrandRelation: 0, 
            projectTypeId: null, 
            projectTypeName: null, 
            taskTemplateTaskRelations: []
        });
    const [templateDetails, setTemplateDetails] = useState(parseTaskDetails);
    const [taskTemplateShow, setTaskTemplateShow] = useState(false);
    const [taskCount, setTaskCount] = useState(0);
    const [templateTrigger, setTemplateTrigger] = useState(false);
    const [deleteType, setDeleteType] = useState('');
    const [deleteProjectTypeId, setDeleteProjectTypeId] = useState(null);
    const [error, setError] = useState('');
    const [open, setOpen] = useState(false);

    const handleCloseDeletePopup = () => {
        setShowDeletePopup(false);
    }

    const handleShowDeleteUserPopup = () => {
        setShowDeletePopup(true);
    }

    useEffect(() => {
        if(addTaskShow) {
            const headers = [
                { "name": "Task", "sort": true, "width": "200px" },
                { "name": "Order", "sort": true, "width": "200px" },
                { "name": "Action", "sort": false, "width": "100px" }
            ];
            setTableHeaders(headers);
        } else {
            const headers = [
                { "name": "Task", "sort": true, "width": "200px" },
                { "name": "Order", "sort": true, "width": "200px" },
                { "name": "", "sort": false, "width": "100px" }
            ];
            setTableHeaders(headers);
        }
        handleTaskDetails(templateDetails);
    }, [templateTrigger, taskToggle, addTaskShow, templateDetails])

    const handleClose = () => {
        setShow(false);
    }

    const handleShow = (projectTypeId) => {
        for(var i = 0; i < templateDetails.length; i++) {
            if(templateDetails[i].projectTypeId == projectTypeId) {
                setTaskCount(templateDetails[i].taskTemplateTaskRelations.length);
            }
        }
        setShow(true);
        setTaskError('');
        setTaskDetailsshow({
            ...taskDetailsshow,
            projectTypeId: projectTypeId,
            idTaskEntityRelation: 0,
            taskName: null,
            order: "1"
        });
    }

    const getDetails = (newTask) => {
        // Incrementing the order if the same order is selected.
        for(var i = 0; i < templateDetails.length; i++) {
            if(templateDetails[i].projectTypeId == newTask.projectTypeId) {
                (templateDetails[i]["taskTemplateTaskRelations"] != null && templateDetails[i]["taskTemplateTaskRelations"].length > 0) && templateDetails[i]["taskTemplateTaskRelations"].map((item => {
                    if(item.order >= newTask.order) {
                        item.order = item.order+1
                    }
                }))
                templateDetails[i]["taskTemplateTaskRelations"].push(newTask);
            }
        }
        setTemplateDetails(templateDetails);
        setTemplateTrigger(!templateTrigger);

        // setTaskDetails([newTask, ...taskDetails])
        // setSortingDetails([newTask, ...taskDetails])
    }

    useEffect(() => {
        templateDetails.map((item) => {
            item["taskTemplateTaskRelations"].sort((a, b) => (a.order > b.order) ? 1 : -1)
        })
        setTemplateDetails([...templateDetails])
    }, [templateTrigger])

    const handleDelete = (index, order, projectId) => {
        setDeleteType('task');
        setDeleteProjectTypeId(projectId);
        setDeletedTaskIndex(index);
        setDeletedTaskOrder(order);
        handleShowDeleteUserPopup();
    }

    const handleTemplateDelete = (index, order) => {
        setDeleteType('template');
        setDeletedTaskIndex(index);
        setDeletedTaskOrder(order);
        handleShowDeleteUserPopup();
    }

    const deleteTask = () => {
        templateDetails != null && templateDetails.length > 0 && templateDetails.map(item => {
            if(item.projectTypeId == deleteProjectTypeId) {
                item['taskTemplateTaskRelations'].splice(deletedTaskIndex, 1);
                item['taskTemplateTaskRelations'].map((item) => {
                    if(item.order > deletedTaskOrder) {
                        item.order = item.order - 1
                    }
                })
            }
        })
        setTemplateDetails([...templateDetails]);
        handleCloseDeletePopup();
    }

    const deleteTemplate = () => {
        templateDetails.splice(deletedTaskIndex, 1);
        setTemplateDetails([...templateDetails]);
        handleCloseDeletePopup();
    }

    const handleSort = (dataset) => {
        setSortValues({
            sortBy: dataset.sortBy,
            sortType: dataset.sortType
        })
        if(dataset.sortBy == "task") {
            if(dataset.sortType == "asc") {
                taskDetails.sort((a, b) => (a.taskName.toUpperCase() > b.taskName.toUpperCase()) ? 1 : -1);
            } else {
                taskDetails.sort((a, b) => (a.taskName.toUpperCase() < b.taskName.toUpperCase()) ? 1 : -1);
            }
        } else {
            if(dataset.sortType == "asc") {
                taskDetails.sort((a, b) => (a.order > b.order) ? 1 : -1);
            } else {
                taskDetails.sort((a, b) => (a.order < b.order) ? 1 : -1);
            }
        }
        // setTaskDetails([...taskDetails])
    }

    const handleShowAddTemplate = () => {
        setTaskTemplateShow(true);
        setTaskTemplateDetails({
            ...taskTemplateDetails,
            idTaskTemplateBrandRelation: 0,
            projectTypeId: null,
            projectTypeName: "Select Project Type",
            taskTemplateTaskRelations: []
        });
    }

    const handleTaskTemplateClose = () => {
        setTaskTemplateShow(false);
    }

    const getTaskTemplateDetails = (newTemplate) => {
        if(newTemplate.projectTypeId != null && newTemplate.projectTypeId != 0) {
            var isExist = false;
            for(var i = 0; i < templateDetails.length; i++) {
                if(newTemplate.projectTypeId == templateDetails[i].projectTypeId) {
                    isExist = true
                    setError(`This task template is already exist`)
                    setOpen(true);
                    break;
                }
            }
            if(!isExist) {
                handleTaskTemplateClose();
                setTemplateDetails([...templateDetails, newTemplate])
            }
        } else {
            setError(`Project Type is mandatory`);
            setOpen(true);
        }
    }

    return(
        <>
            <div className='tasks-container'>
                {console.log("Create Template Details", templateDetails)}
                <div className='task-template-container'>
                    <div className='task-header'>
                        <div className='header1'>Tasks</div>
                        {addTaskShow && <div className='header2' onClick={handleShowAddTemplate}>Add Task Templates</div>}
                    </div>
                </div>
                {templateDetails != null && templateDetails.length > 0 ? 
                    <div>
                        {templateDetails != null && templateDetails.length > 0 && templateDetails.map((item, index) => {
                        return(
                            <div className='entity-tasks-container'>
                                <div className='task-header'>
                                    <div className='header1'>{item.projectTypeName}
                                        {addTaskShow ? 
                                            (<span className='delete-template'
                                            onClick={() => handleTemplateDelete(index, item.order)}>Delete Template</span>) :("")}
                                    </div>
                                    {addTaskShow && <div className='header2' onClick={() => handleShow(item.projectTypeId)}>Add Tasks</div>}
                                </div>
                                <div className='task-body'>
                                    <div className='table-view-container'>
                                        <div className='list-items'>
                                            <table>
                                                <thead>
                                                    <tr className='heading-row'>
                                                        {tableHeaders != null && tableHeaders.map((item, index) => {
                                                            return (
                                                                <>
                                                                    <th className={`${'heading-data'+index}`} style={{ minWidth: `${item.width}` }}>
                                                                        <div className='flex-display'>
                                                                            <div className='label'>{item.name}</div> 
                                                                            {/* {item.sort &&
                                                                            (<div className='sort-arrows'>
                                                                                {
                                                                                    !(sortValues.sortBy === (item.name).toLowerCase() && sortValues.sortType === 'asc') &&
                                                                                    (<img className='uparrow' src={upsort} alt="uparrow" 
                                                                                    data-sort-by={(item.name).toLowerCase()} data-sort-type='asc' onClick={(e) => handleSort(e.target.dataset)}></img>)                                                                                       
                                                                                }
                                                                                {
                                                                                    !(sortValues.sortBy === (item.name).toLowerCase() && sortValues.sortType === 'desc') &&
                                                                                    (<img className='downarrow' src={downsort} alt="downarrow"
                                                                                    data-sort-by={(item.name).toLowerCase()} data-sort-type='desc' onClick={(e) => handleSort(e.target.dataset)}></img>)                                                                                        
                                                                                }
                                                                            </div>)}   */}
                                                                        </div>                                  
                                                                    </th>
                                                                </>
                                                            )
                                                        })}
                                                    </tr>
                                                </thead>
                                                {
                                                    item.taskTemplateTaskRelations && item.taskTemplateTaskRelations.length === 0 ? <p className="no-result">No results found</p> :
                                                    <tbody>
                                                        {item.taskTemplateTaskRelations.length > 0 && item.taskTemplateTaskRelations.map((subitem, index) => {
                                                            return (
                                                                <tr>
                                                                    <td className='task-data1'>{subitem.taskName}</td>
                                                                    <td className='task-data2'>{subitem.order}</td>
                                                                    {<td className='task-data3'>
                                                                        <div>
                                                                            {addTaskShow ? 
                                                                            (<img id={`${'trash'+index}`} className='trash' src={trash} alt="delete" 
                                                                            onClick={() => handleDelete(index, subitem.order, item.projectTypeId)}></img>) :
                                                                            ("")}
                                                                        </div>
                                                                    </td>}
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                }
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                            })  
                        }
                    </div> : 
                    <p className="no-result">No results found</p>
                }

                {/* Showing delete popup */}
                <DeleteItem show={showDeletePopup} handleClose={handleCloseDeletePopup} deleteApiCall={deleteType == 'task' ? deleteTask : deleteTemplate} enable={true}/>

                {/* Showing Add Template popup */}
                <AddTaskTemplate setTaskTemplateDetails={setTaskTemplateDetails} taskTemplateDetails={taskTemplateDetails} taskTemplateShow={taskTemplateShow} handleTaskTemplateClose={handleTaskTemplateClose} getTaskTemplateDetails={getTaskTemplateDetails}/>

                {/* Showing Add Task popup */}
                <AddTask setTaskDetailsshow={setTaskDetailsshow} taskDetailsshow={taskDetailsshow} show={show} handleClose={handleClose} getDetails={getDetails} taskCount={taskCount} taskerror={taskerror} setTaskError={setTaskError}/>

                <Snackbars error={error} open={open} setOpen={setOpen}/>
            </div>
        </>
    )
}
 export default EntityTasks;